import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-field-passport-link',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './field-passport-link.component.html',
  styleUrl: './field-passport-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldPassportLinkComponent {
  @Input() fieldId: string | null = null;
  @Input() fieldName: string | null = null;

  get url(): string | null {
    const id = this.fieldId?.trim();
    if (!id) {
      return null;
    }
    return `${window.location.origin}/electronic-field-map/fields/${id}/general`;
  }

  get displayText(): string {
    const name = this.fieldName?.trim();
    if (name) {
      return name;
    }
    return '';
  }
}
